export function setLocalStorageData(name, value, json = false) {
  if (typeof value === 'undefined') {
    value = null;
  }

  if (json) {
    value = JSON.stringify(value);
  }
  localStorage.setItem(name, value);
  window.dispatchEvent(new Event('storage'));
}

export function getLocalStorageData(name, json = false) {
  const data = localStorage.getItem(name);

  if (data !== null) {
    return json ? JSON.parse(data) : data;
  }

  return null;
}
